import SATTestQ from '@/queries/SATTestQ'
import { useQuery } from '@/client/context/query'
import {
  type ProgramSlugWithIterations,
  SAT_BOOTCAMP_PROGRAM_SLUG,
} from '@/client/services/programs/constants'
import { getProgramIterationOpenForRegistration } from '@/client/services/programs/getProgramIterationHelpers'
import satTestToProgramIteration from '@/client/services/programs/satTestToProgramIteration'
import type { ProgramIteration } from '@/client/services/programs/types'

export default function useProgramIterationOpenForRegistration({
  type,
  programSlug,
}: {
  type: 'learner' | 'tutor'
  programSlug: ProgramSlugWithIterations | null
}): ProgramIteration | null {
  const query = useQuery()

  if (programSlug == null) {
    return null
  }

  if (programSlug === SAT_BOOTCAMP_PROGRAM_SLUG) {
    // earliest program for which registration deadline has not passed
    const satTest = query.one(
      type === 'learner'
        ? SATTestQ.getSATTestOpenForLearnerRegistration()
        : SATTestQ.getSATTestOpenForTutorRegistration()
    )
    const iterationDetails = satTestToProgramIteration(satTest)
    return iterationDetails.id !== 0 ? iterationDetails : null
  }

  return getProgramIterationOpenForRegistration(programSlug, type)
}
